import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Flag from '@atlaskit/flag';
import InfoIcon from '@atlaskit/icon/glyph/check-circle';
import { B300 } from '@atlaskit/theme/colors';
var messages = defineMessages({
  refreshBanner: {
    id: 'embedded.confluence.login-page.refresh-page-banner',
    description: 'The banner displayed prompting a user to refresh the page',
    defaultMessage: 'After logging in, this page should refresh automatically. If not, you can click here to refresh'
  },
  refreshBannerLink: {
    id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
    description: 'A link to refresh the page',
    defaultMessage: 'Refresh page'
  }
});
export var RefreshBanner = function RefreshBanner(_ref) {
  var reloadEP = _ref.reloadEP;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Flag, {
    icon: /*#__PURE__*/React.createElement(InfoIcon, {
      primaryColor: "var(--ds-icon-information, ".concat(B300, ")"),
      label: "Info"
    }),
    id: "refreshBanner",
    title: formatMessage(messages.refreshBanner),
    actions: [{
      content: formatMessage(messages.refreshBannerLink),
      onClick: reloadEP
    }]
  });
};
export default RefreshBanner;